module.exports = __webpack_public_path__ + "static/img/banliliucheng.7441c32d.png";